import { render, staticRenderFns } from "./fccGestaoArquivosListar.vue?vue&type=template&id=99d6c63a"
import script from "./fccGestaoArquivosListar.vue?vue&type=script&lang=js"
export * from "./fccGestaoArquivosListar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports